import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a9d5200"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hr-tile" }
const _hoisted_2 = { class: "breadcrumbs" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "User Profile", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: '/' }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          })
        ]),
        (_ctx.$route.matched.length == 2)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true),
        (_ctx.$route.matched.length > 2)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.$route.matched, (match, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: match.path,
                class: "breadcrumb-item"
              }, [
                (i < _ctx.$route.matched.length - 1)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: match.name, params: _ctx.$route.params}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(match.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                (i == _ctx.$route.matched.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(match.name), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_router_view, {
      career: _ctx.career,
      user: _ctx.user,
      isOwnProfile: _ctx.isOwnProfile
    }, null, 8, ["career", "user", "isOwnProfile"])
  ], 64))
}